<app-nav-bar></app-nav-bar>
<app-dashboard-bar></app-dashboard-bar>
<div class="bloc_sec32 bottom_de32">
  <div class="block_div32">
    <div class="block32_cont32">
      <p class="bol32_text32">
        John Doe higlighted
        <span class="text32_bold32"> Psalms 147:3 NIV</span>
      </p>
      <p class="lig32_ht32">
        He heals the broken-hearted and binds up their wounds.
      </p>
      <p class="seq32_ure32">Psalms 147:3 NIV</p>
    </div>
    <div class="tim32_t32">
      <p class="tim2_sho32">2 days ago</p>
    </div>
  </div>
  <div class="bott32_om32">
    <div class="blo32_kbott32">
      <a href="javascript:void(0);"
        ><img src="assets/images/heart-shape-outline.png" alt=""
      /></a>
      <a href="javascript:void(0);"
        ><img src="assets/images/comment.png" alt=""
      /></a>
      <a href="javascript:void(0);"
        ><img src="assets/images/share.png" alt=""
      /></a>
    </div>
    <div class="mo32_re32">
      <a href="javascript:void(0);">More</a>
    </div>
  </div>
</div>
<div class="bloc_sec32 bottom_de32">
  <div class="block_div32">
    <div class="block32_cont32">
      <p class="bol32_text32">
        John Doe higlighted
        <span class="text32_bold32"> Psalms 147:3 NIV</span>
      </p>
      <p class="lig32_ht32">
        He heals the broken-hearted and binds up their wounds.
      </p>
      <p class="seq32_ure32">Psalms 147:3 NIV</p>
    </div>
    <div class="tim32_t32">
      <p class="tim2_sho32">2 days ago</p>
    </div>
  </div>
  <div class="bott32_om32">
    <div class="blo32_kbott32">
      <a href="javascript:void(0);"
        ><img src="assets/images/heart-shape-outline.png" alt=""
      /></a>
      <a href="javascript:void(0);"
        ><img src="assets/images/comment.png" alt=""
      /></a>
      <a href="javascript:void(0);"
        ><img src="assets/images/share.png" alt=""
      /></a>
    </div>
    <div class="mo32_re32">
      <a href="javascript:void(0);">More</a>
    </div>
  </div>
</div>
